import { useMutation } from '@apollo/client';
import { Button, message, Tooltip } from 'antd';
import React from 'react';
import { getInventoryUnitApis, hasLibraryScope } from './apiConfig';
import { downloadFileFromUrl } from './utils';

const DownloadQrCodesButton = ({
  isLibrary = false,
  libraryId,
  selectedInventoryIds = [],
  selectedUnitIds,
  onSuccess,
  ...buttonProps
}) => {
  const isUnitMode = Array.isArray(selectedUnitIds);
  const { download: downloadApi } = getInventoryUnitApis(isLibrary);
  const [downloadQrCodes, { loading }] = useMutation(downloadApi?.document, {
    onError() {},
  });

  const selectedCount = isUnitMode
    ? selectedUnitIds?.length || 0
    : selectedInventoryIds?.length || 0;

  const handleDownloadQrCodes = async () => {
    const response = await downloadQrCodes({
      variables: downloadApi?.getVariables({
        libraryId,
        libraryInventoryIds:
          !isUnitMode && selectedCount ? selectedInventoryIds : null,
        unitIds: isUnitMode ? selectedUnitIds : null,
      }),
    });
    const result = response?.data?.[downloadApi?.key];
    if (!result) return;

    if (result?.data?.isBackgroundJob) {
      message?.success(
        result?.message ||
          'QR codes are being prepared. You will be notified once ready.',
      );
      if (onSuccess) {
        onSuccess();
      }
      return;
    }
    if (result?.data?.fileUrl) {
      await downloadFileFromUrl(result?.data?.fileUrl);
      if (onSuccess) {
        onSuccess();
      }
    } else {
      message?.error('QR codes file is not available for download');
    }
  };

  const getTooltipTitle = () => {
    if (isUnitMode) {
      return selectedCount
        ? `Download QR codes for the ${selectedCount} selected ${
            selectedCount === 1 ? 'unit' : 'units'
          }.`
        : 'Select one or more units to download their QR codes.';
    }
    return selectedCount
      ? `Download QR codes for the ${selectedCount} selected ${
          selectedCount === 1 ? 'toy' : 'toys'
        } only. Clear the selection to download for the whole library.`
      : 'Download QR codes for all toys in this library. To download for specific toys, select their rows first.';
  };

  return (
    <Tooltip title={getTooltipTitle()} placement="bottom">
      <Button
        {...buttonProps}
        loading={loading}
        disabled={
          !hasLibraryScope(isLibrary, libraryId) ||
          (isUnitMode && !selectedCount)
        }
        onClick={handleDownloadQrCodes}
      >
        {selectedCount ? `Download QRs (${selectedCount})` : 'Download QRs'}
      </Button>
    </Tooltip>
  );
};

export default DownloadQrCodesButton;
